const CryptoJS = require('crypto-js');

module.exports = function decrypt({ data, initVector, Securitykey }) {
  var options = { mode: CryptoJS.mode.CBC, iv: initVector };
  return CryptoJS.AES.decrypt(data, Securitykey, options).toString(
    CryptoJS.enc.Utf8
  );
};
